module.exports = __webpack_public_path__ + "img/img12.552e2e24.png";